// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdw-editor-main {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow-y: auto;
    box-sizing: border-box;
}

.rdw-editor-toolbar {
    padding: 6px 5px 0;
    border-radius: 2px;
    border: 1px solid #F1F1F1;
    display: flex;
    justify-content: flex-start;
    background: white;
    flex-wrap: wrap;
    font-size: 15px;
    margin-bottom: 5px;
    user-select: none;
}

.public-DraftStyleDefault-block {
    margin: 1em 0;
}

.rdw-editor-wrapper:focus {
    outline: none;
}

.rdw-editor-wrapper {
    box-sizing: content-box;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow-y: auto;
}

.rdw-editor-main blockquote {
    border-left: 5px solid #f1f1f1;
    padding-left: 5px;
}

.rdw-editor-main pre {
    background: #f1f1f1;
    border-radius: 3px;
    padding: 1px 10px;
}

.editor-class {
/*    color: #f00;
    font-size: 20px;
*/    margin: 0;
}

.rdw-suggestion-option {
    padding: 7px 5px;    
    background-color: rgb(40,36,61) !important;
    border-bottom: 1px solid #f1f1f1;
}

.rdw-suggestion-dropdown{
    width: 200px;
}

path {
    fill: red,    

}
`, "",{"version":3,"sources":["webpack://./src/features/common2/Templating/ContentEditor.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;AACA;;CAEC,KAAK,SAAS;AACf;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;IAC1C,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;;AAEJ","sourcesContent":[".rdw-editor-main {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1 1 auto;\r\n    overflow-y: auto;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.rdw-editor-toolbar {\r\n    padding: 6px 5px 0;\r\n    border-radius: 2px;\r\n    border: 1px solid #F1F1F1;\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    background: white;\r\n    flex-wrap: wrap;\r\n    font-size: 15px;\r\n    margin-bottom: 5px;\r\n    user-select: none;\r\n}\r\n\r\n.public-DraftStyleDefault-block {\r\n    margin: 1em 0;\r\n}\r\n\r\n.rdw-editor-wrapper:focus {\r\n    outline: none;\r\n}\r\n\r\n.rdw-editor-wrapper {\r\n    box-sizing: content-box;\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1 1 auto;\r\n    overflow-y: auto;\r\n}\r\n\r\n.rdw-editor-main blockquote {\r\n    border-left: 5px solid #f1f1f1;\r\n    padding-left: 5px;\r\n}\r\n\r\n.rdw-editor-main pre {\r\n    background: #f1f1f1;\r\n    border-radius: 3px;\r\n    padding: 1px 10px;\r\n}\r\n\r\n.editor-class {\r\n/*    color: #f00;\r\n    font-size: 20px;\r\n*/    margin: 0;\r\n}\r\n\r\n.rdw-suggestion-option {\r\n    padding: 7px 5px;    \r\n    background-color: rgb(40,36,61) !important;\r\n    border-bottom: 1px solid #f1f1f1;\r\n}\r\n\r\n.rdw-suggestion-dropdown{\r\n    width: 200px;\r\n}\r\n\r\npath {\r\n    fill: red,    \r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
